module.exports = __webpack_public_path__ + "media/customizations/regencyatsrr/logo-80df10e214760b13b5a788bbd5e207d1.png";